<div
  id="tooltip"
  class="relative bg-white rounded p-4 flex flex-col border border-gray-200 max-w-xs max-h-150"
  [attr.data-testid]="'popup-component-' + popupService.mode()"
>
  <div class="flex flex-row items-center justify-between mb-2">
    <h5 class="!m-0 break-words" data-testid="popup-title">
      {{ titleText() }}
    </h5>

    <button mat-icon-button class="flex-shrink-0" (click)="removeObject()">
      <mat-icon svgIcon="icn-close" />
    </button>
  </div>

  @if (popupService.mode() === PopupMode.ResidentialRealEstate || popupService.mode() === PopupMode.CommercialRealEstate) {
    <!-- Multiple Compare objects -->
    @if (popupService.selectedCompareObjects()?.length > 1) {
      <div>
        <mat-form-field>
          <mat-label>
            {{ "Table.Header.Date.TransactionDate" | transloco }}
          </mat-label>
          <mat-select [ngModel]="popupService.selectedCompareObjects()" (ngModelChange)="selectCompareObject($event)">
            @for (objectItem of popupService.selectedCompareObjects(); track objectItem) {
              <mat-option [value]="objectItem">
                @if (objectItem.priceDate) {
                  {{
                    objectItem.priceDate.month ? objectItem.priceDate.year + "-" + objectItem.priceDate.month : objectItem.priceDate.year
                  }}
                }
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }

    <!-- Residential Real Estate -->
    @if (popupService.selectedCompareObject() && popupService.selectedCompareObject().objectInformation) {
      <app-residential-popup-info
        [objectInformation]="popupService.selectedCompareObject().objectInformation"
        [priceTitle]="priceTitle() | transloco"
        [priceValue]="priceValue()"
      />
    }
  }

  @if (popupService.mode() === PopupMode.Portfolio) {
    @if (popupService.selectedPortfolioObject()) {
      <div class="mb-2">
        <app-portfolio-popup-info [portfolioObject]="popupService.selectedPortfolioObject()" />
      </div>
    }

    <!-- Multiple portfolio location objects -->
    @if (!popupService.selectedPortfolioObject() && popupService.selectedPortfolioLocation() && popupService.selectedPortfolioDetails()) {
      @if (popupService.selectedPortfolioLocation()?.portfolioLocationObjects?.length > 1) {
        <div>
          <mat-form-field appearance="outline">
            <mat-label>
              {{ "Module.ObjectInformation.ObjectNumber" | transloco }}
            </mat-label>
            <mat-select [ngModel]="null" (ngModelChange)="selectPortfolioObject($event)">
              @for (objectItem of popupService.selectedPortfolioDetails()?.portfolioLocationsDetailObjects; track objectItem) {
                <mat-option [value]="objectItem">
                  {{
                    !objectItem.customerId || objectItem.customerId.trim() === ""
                      ? ("Properties.BooleanType.0" | transloco)
                      : objectItem.customerId
                  }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    }
  }

  <!-- Layer -->
  @if (popupService.isLayerPopup()) {
    <div class="grid-min-full grid-column-gap">
      @for (mapItem of mapFeatureInfoService.mapFeatureInfo.features; track mapItem) {
        <div class="colorbox !min-w-5 !min-h-5" [style.background-color]="getLegendForMapFeature(true, mapItem.properties.value)"></div>
        <div>{{ getLegendForMapFeature(false, mapItem.properties.value) }}</div>
      }
    </div>
  }

  @if (
    popupService.mode() !== PopupMode.Portfolio &&
    popupService.mode() !== PopupMode.ResidentialRealEstate &&
    popupService.mode() !== PopupMode.CommercialRealEstate
  ) {
    <!-- Other -->
    <div class="flex-1 overflow-y-auto pr-2">
      @if (popupService.popupObjectList.length > 0 && popupService.mode() !== PopupMode.ResidentialRealEstate) {
        <div class="grid grid-cols-1 gap-2">
          @for (item of popupService.popupObjectList(); track item) {
            <div class="grid grid-cols-2 gap-2">
              <div> {{ setPropertyText(item) }}</div>
              <div>{{ setProperty(item) }}</div>
            </div>
          }
        </div>
      }
    </div>
  }

  <div class="pt-1 mt-auto">
    @if (popupService.allowPopupNavigation()) {
      <button mat-button mat-raised-button color="accent" (click)="navigate()" class="w-full">
        {{ buttonText() | transloco }}
      </button>
    }
  </div>
</div>
